<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<h1 mat-dialog-title>{{ data.title }}</h1>

<form mat-dialog-content [formGroup]="choicesGroup">
	<div *ngFor="let line of contentLine$ | async">
		{{ line }} &nbsp;
		<!-- Always add a &nbsp; in case a line is intentionally empty, to act as vertical space -->
	</div>
	<mat-radio-group class="grid-layout" formControlName="choice">
		<mat-radio-button class="modal-radio-button" *ngFor="let choice of data.choices" [value]="choice">
			{{ choice }}
		</mat-radio-button>
	</mat-radio-group>
</form>

<div mat-dialog-actions class="action-buttons">
	<button mat-button color="{{ data.noButtonColor }}" (click)="onNo()">
		{{ data.noButtonText }}
	</button>
	<button
		mat-raised-button
		cdkFocusInitial
		color="{{ data.yesButtonColor }}"
		(click)="onButtonChoiceSelect()"
	>
		{{ data.yesButtonText }}
	</button>
</div>
